export default __webpack_public_path__ + "static/media/logo06.6f5bf23c.png";